module.exports = __webpack_public_path__ + "static/home-image-6_d-841edabd4c518a28956151c5a65b1654.jpg";